import { gettype } from './gettype'

/**
 * データが一致しているか
 *
 * @param {*} x
 * @param {*} y
 * @returns {Boolean} データが一致していれば true
 */
export function same (x, y) {
  const typex = gettype(x)
  const typey = gettype(y)
  if (typex !== typey) {
    return false
  }
  switch (typex) {
    case 'array':
      return sameArray(x, y)
    case 'object':
      return sameObject(x, y)
    case 'regexp':
      return (x.toString() === y.toString())
    case 'date':
      return x.valueOf() === y.valueOf()
    default:
      return x === y
  }
}

/**
 * 配列の内容が一致しているか
 *
 * @param {Array} x
 * @param {Array} y
 * @returns {Boolean} 配列の内容が一致していれば true
 */
function sameArray (x, y) {
  if (x.length !== y.length) {
    return false
  }

  for (let i = 0, len = x.length; i < len; ++i) {
    if (!same(x[i], y[i])) {
      return false
    }
  }
  return true
}

/**
 * オブジェクトの内容が一致しているか
 *
 * @param {Object} x
 * @param {Object} y
 * @returns {Boolean} オブジェクトの内容が一致していれば true
 */
function sameObject (x, y) {
  const keysX = Object.keys(x)
  const keysY = Object.keys(y)

  if (keysX.length !== keysY.length) {
    return false
  }

  for (let i = 0, len = keysX.length; i < len; ++i) {
    const k = keysX[i]
    if (!same(x[k], y[k])) {
      return false
    }
  }
  return true
}
